module.exports = __webpack_public_path__ + "static/media/l_dot_8.78907a3f.png";